<template>
  <div class="glasson-container">
    <a-row class="box" type="flex">
      <!-- Body -->
      <a-col class="height-100" flex="auto">
        <try-on ref="plugin" :fetching="fetching" />
        <!-- <customize-menu :fetching="fetching" @switch-option="switchOption" /> -->
      </a-col>
      <!-- Side -->
      <a-col class="height-100" :flex="screenWidth >= 576 ? '120px' : '85px'">
        <!-- <side-menu :setFetching="setFetching" :snapshot="snapshot" /> -->
        <side-menu :screenWidth="screenWidth" />
      </a-col>
    </a-row>
    <!-- Footer -->
    <bottom-menu :setFetching="setFetching" :snapshot="snapshot" />
  </div>
</template>

<script>
import Vue from "vue";
import { Modal } from "ant-design-vue";
// import { CustomizeMenu } from "../CustomizeMenu";
import { TryOn } from "../TryOn";
import { SideMenu } from "../SideMenu";
import { BottomMenu } from "../BottomMenu";

const STYLE = [
  "Square,5e7e8408-2111-4b09-9c01-63889008cceb.png,6983ef11-bba1-474f-8c9c-31b3f2adf569.zip,5707",
  "Oval,31960b9b-291e-4e60-b036-6f6564d6d62b.png,420b246f-8a3e-4ce4-ae97-eb33ac166edf.zip,5373",
  "Round,376e940a-b6ec-4469-8c0a-6d68952e9147.png,a6df3e00-7dc4-458d-9b45-002e2b0b29e5.zip,5686",
  "Wellington,4aef62d6-dc7b-44a7-b2b5-9621eaa3bbd4.png,f0ef900b-c0ec-4709-8408-447013d9f348.zip,5710",
  "Boston,cf92ed93-009e-42ea-a24d-93da2ff098cf.png,064455d1-aac3-4b94-ac61-abd6c5a90046.zip,5693",
  "Browline,f3cf312f-e9e9-4983-9d65-61e40f40770a.png,55ced4d8-ac13-4449-9d57-bdbc16cdcc95.zip,6246",
  "Two-point,77aa4d07-02d9-4861-87ab-4c1da6ff0c1c.png,a4c6574d-aafc-400b-a652-66d9ba8b3e41.zip,6190",
  "Other,bd07cd30-f0cf-4672-80e9-97f643b2b5f5.png,2b6fa0d8-1d00-44a9-887e-ad0462a72987.zip,5911"
];

const LENS = [
  "Clear;255,255,255,0.15",
  "BrightSun Grey;51,51,51,0.75",
  "BrightSun Black;0,0,0,0.75",
  "Skyblue;67,206,255,0.15",
  "Vivid Nite;255,248,150,0.5",
  "Rapide;255, 124, 128, 0.5",
  "Blue Mirror;0,122,209",
  "Gold Mirror;232,182,56",
  "Red Mirror;222,82,70",
  "Silver Mirror;160,160,160"
];

const TEXTURE = [
  "Onyx-1,assets/10.jpg",
  "Onyx-2,assets/11.jpg",
  "Onyx-3,assets/12.jpg",
  "Onyx-4,assets/20.jpg",

  "Azure-1,assets/22.jpg",
  "Azure-2,assets/23.jpg",
  "Azure-3,assets/71.jpg",
  "Azure-4,assets/41.jpg",
  "Azure-5,assets/57.jpg",

  "Walnut-1,assets/30.jpg",
  "Walnut-2,assets/31.jpg",
  "Walnut-3,assets/34.jpg",
  "Walnut-4,assets/62.jpg",

  "Indigo-1,assets/40.jpg",
  "Indigo-2,assets/42.jpg",
  "Indigo-3,assets/44.jpg",
  "Indigo-4,assets/45.jpg",

  "Roseate-1,assets/82.jpg",
  "Roseate-2,assets/73.jpg",
  "Roseate-3,assets/91.jpg",
  "Roseate-4,assets/90.jpg",
  "Roseate-5,assets/92.jpg",

  "Apricot-1,assets/64.jpg",
  "Apricot-2,assets/53.jpg",
  "Apricot-3,assets/50.jpg",
  "Apricot-4,assets/60.jpg"
];

export default {
  components: {
    // CustomizeMenu,
    TryOn,
    SideMenu,
    BottomMenu
  },
  data() {
    return {
      fetching: true,
      screenWidth: window.innerWidth
    };
  },
  created() {
    this.fetchOptions();
  },
  mounted() {
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  methods: {
    onWindowResize() {
      this.screenWidth = window.innerWidth;
    },
    snapshot() {
      return this.$refs.plugin.snapshot();
    },
    setFetching(fetching) {
      this.fetching = fetching;
    },
    switchOption(option) {
      Vue.set(this.selectedOpt, option.kind, option);
    },
    async fetchOptions() {
      try {
        const searchParams = new URLSearchParams(window.location.search);
        const accountId = searchParams.get("accountId") || 3;
        const res = await fetch(window.GLASSON_CONFIG.ENDPOINT + "Options/all?accountId=" + accountId);
        const { data } = await res.json();

        const fixedData = {
          style: STYLE.map(csvLine => {
            const cells = csvLine.split(",");
            return { kind: "style", sku: cells[0], texture: cells[1], model: cells[2], productId: cells[3] };
          }),
          rim: TEXTURE.map(csvLine => {
            const cells = csvLine.split(",");
            return { kind: "rim", sku: cells[0], texture: cells[1] };
          }),
          temple: TEXTURE.map(csvLine => {
            const cells = csvLine.split(",");
            return { kind: "temple", sku: cells[0], texture: cells[1] };
          }),
          lens: LENS.map(csvLine => {
            const cells = csvLine.split(";");
            return { kind: "lens", sku: cells[0], colors: cells[1] };
          })
        };

        this.$store.commit("putOptions", Object.assign(data, fixedData));
        // Set first option as default
        Object.keys(data).forEach(kind => {
          this.$store.commit("selectOption", data[kind][0]);
        });
      } catch (err) {
        Modal.error({ title: "Exception", content: err.message });
      } finally {
        this.fetching = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.glasson {
  &-container {
    width: 100%;
    height: 100vh;
    padding: 8px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    & .box {
      flex: 1;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
      overflow: hidden;
    }

    .actions-btn-group {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .randomize-btn {
        border: 2px solid #2f80ed;
      }

      .favorite-btn {
        margin-top: 16px;
        border: 2px solid #2f80ed;

        @media only screen and (max-width: 768px) {
          margin-top: 0px;
        }
      }

      @media only screen and (max-width: 768px) {
        flex-direction: row;
        justify-content: space-around;
        align-items: flex-start;
      }
    }

    .suggestion-group {
      width: 100%;
      margin-top: 24px;
      border: 2px solid #9a9b9c;
      border-radius: 8px;
      padding: 8px 48px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      @media only screen and (max-width: 768px) {
        flex-direction: row;
        white-space: nowrap;
        border-radius: 0;
        border: transparent;
      }

      &--title {
        color: #9a9b9c;
        font-size: 16px;

        @media only screen and (max-width: 768px) {
          display: none;
        }
      }

      &--item {
        img {
          width: 100%;
        }
      }
    }

    .order-section {
      margin-top: 64px;
      display: flex;
      justify-content: center;
      align-items: center;

      &--btn {
        border: 2px solid #f9d802;
        border-radius: 25px;
        height: 50px;
        width: 100%;
        background: #f9d802;

        &:hover,
        &:focus {
          color: rgba(0, 0, 0, 0.65);
        }

        @media only screen and (max-width: 768px) {
          width: 60%;
        }
      }

      @media only screen and (max-width: 768px) {
        margin-top: 48px;
      }
    }
  }
}
</style>
